import { gql, useMutation } from '@apollo/client'

export type DeleteAddressVariables = {
  deleteAddressId: string
}

export type DeleteAddressMutation = {
  deleteAddress?: boolean | null
}

export const GQL_MUTATION_DELETE_ADDRESS = gql`
  mutation DeleteAddress($deleteAddressId: ID!) {
    deleteAddress(id: $deleteAddressId)
  }
`

/**
 * Хук для удаления адреса пользователя
 */
export const useMutateDeleteAddress = () =>
  useMutation<DeleteAddressMutation, DeleteAddressVariables>(GQL_MUTATION_DELETE_ADDRESS)
